import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { withRouter } from 'react-router-dom';
import {
  DropdownItem, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown,
} from 'reactstrap';

import { getTimeTrackingReasonsOptions } from '../../../app/store/actions/timeTrackingReasons';
import {
  deleteUserTimeTracking,
  finishUserTimeTracking,
  getUserTimeTrackingByDate,
} from '../../../app/store/actions/userTimeTracking';
import addNotification from '../../../components/notification';
import UserConfirmationModal from '../../../components/pages/userConfirmationModal';
import Table from '../../../components/table/Table';
import ROUTES from '../../../config/routes';
import UserTimeTrackingHelpers from '../../../helpers/userTimeTracking';
import Permissions from '../../../app/services/permissions';

class UserTimeTrackingMonitor extends React.Component {
  static filterColumn = ({ onChange }) => (
    <input
      type="text"
      style={{ width: '100%' }}
      onKeyPress={(event) => {
        if (event.keyCode === 13 || event.which === 13) {
          onChange(event.target.value);
        }
      }}
      onKeyUp={(event) => {
        if (event.target.value === '' && (event.keyCode === 8 || event.which === 8)) {
          onChange(event.target.value);
        }
      }}
    />
  );

  constructor(props) {
    super(props);

    this.breadcrumb = [
      {
        value: (
          <>
            <i className="fas fa-home fa-fw m-t-10 m-r-5" />
            {' '}
            {I18n.t('BEE12' /* Início */)}
          </>
        ),
      },
      { value: I18n.t('BEE4274' /* Apontamentos */) },
      { value: I18n.t('BEE4286' /* Monitor de Apontamentos */), active: true },
    ];

    this.tableColumns = [
      {
        Header: I18n.t('BEE55' /* Ações */),
        accessor: 'action',
        style: { overflow: 'visible', alignSelf: 'center' },
        filterable: false,
        sortable: false,
        width: 100,
        Cell: (rows) => (
          <div style={{ textAlign: 'center' }}>
            <button type="button" className="btn btn-default btn-xs">{I18n.t('BEE55' /* Ações */)}</button>
            <UncontrolledButtonDropdown>
              <DropdownToggle color="default" caret className="btn-xs" />
              <DropdownMenu>
                {!Permissions.checkPermission(ROUTES.P_FINALIZE_USER_TIME_TRACKING) && rows.original.status === 1 ? (
                  <DropdownItem onClick={() => this.setState({
                    showReasonDialog: true,
                    selectedTracking: rows.original,
                    typeAction: 'finish',
                  })}
                  >
                    {I18n.t('BEE1567' /* Finalizar */)}
                  </DropdownItem>
                ) : null}
                {!Permissions.checkPermission(ROUTES.P_DELETE_USER_TIME_TRACKING) ? (
                  <DropdownItem onClick={() => this.setState({
                    openModal: true,
                    selectedTracking: rows.original,
                    typeAction: 'delete',
                  })}
                  >
                    {I18n.t('BEE81' /* Eliminar */)}
                  </DropdownItem>
                ) : null}
              </DropdownMenu>
            </UncontrolledButtonDropdown>
          </div>
        ),
      }, {
        Header: I18n.t('BEE4285' /* Data/Hora Início */),
        accessor: 'startedAt',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 180,
        filterMethod: (filter, row) => {
          const input = _.lowerCase(filter.value);
          const dateFirstOption = moment(row[filter.id]).format('DD MM YYYY');
          const dateSecondOption = moment(row[filter.id]).format('DDMMYYYY');
          if (_.includes(dateFirstOption, input) || _.includes(dateSecondOption, input)) {
            return true;
          }
        },
        Cell: (row) => (
          <span>
            {' '}
            {row.value ? moment(row.value).format('L LTS') : ''}
          </span>
        ),
        Filter: UserTimeTrackingMonitor.filterColumn,
      }, {
        Header: I18n.t('BEE145' /* Filial */),
        accessor: 'branchCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 80,
      }, {
        Header: I18n.t('BEE4276' /* Usuário Tarefa */),
        accessor: 'user.login',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 125,
      }, {
        Header: I18n.t('BEE200' /* Tipo */),
        accessor: 'type',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Cell: (row) => (
          <span>
            {row.value ? UserTimeTrackingHelpers.typeTracking(row.value) : ''}
          </span>
        ),
        Filter: ({ onChange }) => (
          <select
            type="text"
            style={{ width: '100%' }}
            onChange={(event) => { onChange(event.target.value); }}
          >
            <option value="">{I18n.t('BEE793' /* Todos */)}</option>
            {UserTimeTrackingHelpers.typeTracking().map((element, index) => (
              <option key={index} value={element.value}>
                {element.label}
              </option>
            ))}
          </select>
        ),
      }, {
        Header: I18n.t('BEE2770' /* Ordem de Produção */),
        accessor: 'productionOrder.code',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 175,
      }, {
        Header: I18n.t('BEE4277' /* Tarefa Indireta */),
        accessor: 'indirectTask.name',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
      }, {
        Header: I18n.t('BEE4278' /* Data/Hora Final */),
        accessor: 'finishedAt',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 180,
        filterMethod: (filter, row) => {
          const input = _.lowerCase(filter.value);
          const dateFirstOption = moment(row[filter.id]).format('DD MM YYYY');
          const dateSecondOption = moment(row[filter.id]).format('DDMMYYYY');
          if (_.includes(dateFirstOption, input) || _.includes(dateSecondOption, input)) {
            return true;
          }
        },
        Cell: (row) => (
          <span>
            {' '}
            {row.value ? moment(row.value).format('L LTS') : ''}
          </span>
        ),
        Filter: UserTimeTrackingMonitor.filterColumn,
      }, {
        Header: I18n.t('BEE504' /* Total */),
        accessor: 'totalTime',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
      }, {
        Header: I18n.t('BEE224' /* Status */),
        accessor: 'status',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 130,
        Cell: (row) => (
          <span>
            {row.value ? UserTimeTrackingHelpers.statusTracking(row.value) : ''}
          </span>
        ),
        Filter: ({ onChange }) => (
          <select
            type="text"
            style={{ width: '100%' }}
            onChange={(event) => { onChange(event.target.value); }}
          >
            <option value="">{I18n.t('BEE793' /* Todos */)}</option>
            {UserTimeTrackingHelpers.statusTracking().map((element, index) => (
              <option key={index} value={element.value}>
                {element.label}
              </option>
            ))}
          </select>
        ),
      }, {
        Header: I18n.t('BEE4275' /* Motivo Finalização */),
        accessor: 'reason.name',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 300,
      },
    ];

    this.state = {
      openModal: false,
      selectedTracking: {},
      typeAction: '',
      userTimeTrackings: [],
      defaultPageSize: 10,
      defaultSorted: [{ id: 'startedAt', desc: true }],
      startDate: moment().subtract(30, 'd'),
      endDate: moment(),
      reasonsList: [],
      showReasonDialog: false,
      reasonSelected: null,
    };
  }

  async componentDidMount() {
    this.getUserTimeTrackingByDate();

    const reasonsList = await this.props.getTimeTrackingReasonsOptions();

    this.setState({
      reasonsList,
      reasonSelected: reasonsList.length > 0 ? reasonsList[0].value : null,
    });
  }

  getUserTimeTrackingByDate = async () => {
    const { startDate, endDate } = this.state;

    try {
      const userTimeTrackings = await this.props.getUserTimeTrackingByDate(
        moment(startDate).format(),
        moment(endDate).format(),
      );

      if (userTimeTrackings && userTimeTrackings.success === false) {
        addNotification(
          'danger',
          I18n.t('BEE4286' /* Monitor de Apontamentos */),
          I18n.t('BEE4280' /* Nenhum apontamento foi encontrado. */),
          'top-right',
        );
      } else {
        this.setState({ userTimeTrackings });
      }
    } catch (error) {
      const messageError = error.response && error.response.data
        && error.response.data.error && error.response.data.error.message;

      if (messageError) {
        addNotification(
          'danger',
          I18n.t('BEE4286' /* Monitor de Apontamentos */),
          messageError,
          'top-right',
        );
      } else {
        addNotification(
          'danger',
          I18n.t('BEE4286' /* Monitor de Apontamentos */),
          I18n.t('BEE4280' /* Nenhum apontamento foi encontrado. */),
          'top-right',
        );
      }
    }
  };

  handleDateApplyEvent = async (event) => {
    this.setState({
      startDate: event[0],
      endDate: event[1],
    });

    this.getUserTimeTrackingByDate();
  };

  actionTimeTracking = async () => {
    const {
      typeAction, selectedTracking, reasonSelected, reasonsList,
    } = this.state;

    try {
      if (typeAction === 'delete') {
        const deletedTracking = await this.props.deleteUserTimeTracking(selectedTracking.id);

        if (deletedTracking && deletedTracking.success === false) {
          addNotification(
            'danger',
            I18n.t('BEE4286' /* Monitor de Apontamentos */),
            I18n.t('BEE4281' /* Não foi possível eliminar esta tarefa. */),
            'top-right',
          );
        } else {
          addNotification(
            'success',
            I18n.t('BEE4286' /* Monitor de Apontamentos */),
            I18n.t('BEE4321' /* Tarefa excluída com sucesso */),
            'top-right',
          );
        }
      } else if (typeAction === 'finish') {
        const finishedTracking = await this.props.finishUserTimeTracking(selectedTracking.id, reasonSelected);

        if (finishedTracking && finishedTracking.success === false) {
          addNotification(
            'danger',
            I18n.t('BEE4286' /* Monitor de Apontamentos */),
            I18n.t('BEE4282' /* Não foi possível finalizar esta tarefa. */),
            'top-right',
          );
        } else {
          addNotification(
            'success',
            I18n.t('BEE4286' /* Monitor de Apontamentos */),
            I18n.t('BEE4322' /* Tarefa finalizada com sucesso */),
            'top-right',
          );
        }
      } else {
        addNotification(
          'danger',
          I18n.t('BEE4286' /* Monitor de Apontamentos */),
          I18n.t('BEE4282' /* Não foi possível finalizar esta tarefa. */),
          'top-right',
        );
      }

      this.setState(
        {
          selectedTracking: {},
          typeAction: '',
          reasonSelected: reasonsList.length > 0 ? reasonsList[0].value : null,
        },
      );
      await this.getUserTimeTrackingByDate();
    } catch (error) {
      const messageError = error.response && error.response.data
        && error.response.data.error && error.response.data.error.message;

      if (messageError) {
        addNotification(
          'danger',
          I18n.t('BEE4286' /* Monitor de Apontamentos */),
          messageError,
          'top-right',
        );
      } else {
        addNotification(
          'danger',
          I18n.t('BEE4286' /* Monitor de Apontamentos */),
          I18n.t('BEE4282' /* Não foi possível finalizar esta tarefa. */),
          'top-right',
        );
      }
    }
  };

  userConfirmation = async (confirm) => {
    this.setState({ openModal: false });
    if (confirm) {
      await this.actionTimeTracking();
    }
  };

  showUserConfirmModal = async () => {
    const { reasonSelected } = this.state;

    if (reasonSelected) {
      this.setState({ showReasonDialog: false });
      this.setState({ openModal: true });
    } else {
      addNotification(
        'danger',
        I18n.t('BEE4286' /* Monitor de Apontamentos */),
        I18n.t('BEE4323' /* Selecione um motivo para finalizar a tarefa */),
        'top-right',
      );
    }
  };

  setValue = async (attr, value) => {
    await this.setState({
      [`${attr}`]: value,
    });
  };

  createSelect = (value, attr, label, items) => (
    <div className="form-group p-2">
      <label htmlFor={attr}>{label}</label>
      <select
        id={attr}
        className="form-control"
        value={value || ''}
        onChange={(e) => this.setValue(attr, e.target.value)}
      >
        {items.map((item) => (
          <option key={item.value} value={item.value}>{item.label}</option>
        ))}
      </select>
    </div>
  );

  render() {
    const {
      defaultPageSize, defaultSorted, userTimeTrackings, reasonsList, showReasonDialog, reasonSelected,
    } = this.state;

    return (
      <>
        <Table
          breadcrumb={this.breadcrumb}
          headerTitle={I18n.t('BEE4286' /* Monitor de Apontamentos */)}
          wikiHelp={ROUTES.TIME_TRACKING_MONITOR_HELP}
          downloadCSV
          panelHeaderProps={{
            onClickReload: this.getUserTimeTrackingByDate,
            children: I18n.t('BEE4274' /* Apontamentos */).toUpperCase(),
          }}
          datePicker={{
            handleDateApplyEvent: this.handleDateApplyEvent,
          }}
          filterable
          expander
          data={userTimeTrackings}
          columns={this.tableColumns}
          defaultPageSize={defaultPageSize}
          defaultSorted={defaultSorted}
          defaultFilterMethod={(filter, row) => {
            const input = _.lowerCase(filter.value);
            const value = _.lowerCase(row[filter.id]);
            if (_.includes(value, input)) {
              return true;
            }
          }}
        />
        <UserConfirmationModal
          openModal={this.state.openModal}
          confirm={(confirm) => this.userConfirmation(confirm)}
        />
        {(showReasonDialog && (
          <SweetAlert
            confirmBtnText={I18n.t('BEE436' /* Selecionar */)}
            confirmBtnBsStyle="primary"
            cancelBtnBsStyle="default"
            title={I18n.t('BEE4324' /* Selecionar Motivo de Finalização */)}
            onConfirm={() => this.showUserConfirmModal()}
            onCancel={() => this.setState({
              showReasonDialog: false,
              reasonSelected: reasonsList.length > 0 ? reasonsList[0] : null,
            })}
          >
            <div className="mt-4">
              {this.createSelect(
                reasonSelected,
                'reasonSelected',
                I18n.t('BEE4271' /* Motivo de Finalização do Apontamento */),
                reasonsList,
              )}
            </div>
          </SweetAlert>
        ))}
      </>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  getUserTimeTrackingByDate: (
    filterStartDate,
    filterEndDate,
  ) => dispatch(getUserTimeTrackingByDate(filterStartDate, filterEndDate)),
  finishUserTimeTracking: (trackingId, reasonCode) => dispatch(finishUserTimeTracking(trackingId, reasonCode)),
  deleteUserTimeTracking: (trackingId) => dispatch(deleteUserTimeTracking(trackingId)),
  getTimeTrackingReasonsOptions: () => dispatch(getTimeTrackingReasonsOptions()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UserTimeTrackingMonitor));
